import React from "react";

// Links de download dos anexos de uma linha do "Histórico de Análise Gestor".
export default function AnexosHistorico({ anexos, caminhoVirtual }) {
    if (!anexos || anexos.length === 0)
        return null;

    return (
        <>
            {anexos.map((anexo, i) => (
                <div key={i}>
                    <a href={caminhoVirtual + anexo.arquivo} target="_blank" rel="noopener noreferrer">
                        <i className="fas fa-file"></i> {anexo.nomeOriginal}
                    </a>
                </div>
            ))}
        </>
    );
}
